import { Input, InputProps, InputRef } from 'antd'
import { Icon } from 'shared/iconpack'
import useSearchParamInput from 'shared/libs/hooks/useSearchParamInput'

import { ChangeEvent, forwardRef } from 'react'

interface Props extends InputProps {
  paramKey?: string
  onChangeInput?: (value: string) => void
  withPage?: boolean
}
const SearchInput = forwardRef<InputRef, Props>(
  (
    {
      className,
      paramKey = 'search',
      onChangeInput,
      withPage = false,
      prefix,
      ...props
    },
    ref,
  ) => {
    const { searchValue, onChange } = useSearchParamInput({
      paramKey,
      withPage,
    })

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
      if (value.trim() === '') {
        onChange('')
      } else {
        onChange(value)
      }
      if (onChangeInput) onChangeInput(value)
    }

    return (
      <Input
        ref={ref}
        className={`border-light_gray_7 rounded-[12px] ${className}`}
        onChange={handleChange}
        value={searchValue}
        prefix={
          prefix || (
            <Icon
              name="search"
              width={20}
              height={20}
            />
          )
        }
        onKeyDown={(e) => e.stopPropagation()}
        {...props}
      />
    )
  },
)

export default SearchInput
